import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './styles.module.css';

type ButtonGroupProps = {
  alignRight?: boolean;
};

export const ButtonGroup: FC<ButtonGroupProps> = ({ children, alignRight }) => {
  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.alignRight]: alignRight,
      })}
    >
      {children}
    </div>
  );
};
